import { createBrowserClient } from '@insolech/sdk';

const url = import.meta.env.VITE_SUPABASE_URL;
const anonKey = import.meta.env.VITE_SUPABASE_ANON_KEY;

if (!url || !anonKey) {
  console.error('VITE_SUPABASE_URL or VITE_SUPABASE_ANON_KEY missing — set them in .env.local');
}

export const supabase = createBrowserClient({
  url: url ?? '',
  anonKey: anonKey ?? '',
});
